import { UNUSUAL_TEXT } from "./constants";

import { UNUSUAL_TEXT_KEY } from "./constants";

export const UnusualH1 = ({
    children,
    unusualKey,
    additional,
    ...props
}: {
    children: React.ReactNode;
    unusualKey?: UNUSUAL_TEXT_KEY;
    additional?: string;
} & React.HTMLAttributes<HTMLHeadingElement>) => {
    return (
        <h1
            {...(unusualKey && { "unusual-id": `${UNUSUAL_TEXT[unusualKey].TITLE}-${additional}` })}
            {...props}
            data-testid="auto-id-d5b48e1f-2658-4d6f-a074-bd2979d5aa4d">
            {children}
        </h1>
    );
};

export const UnusualH2 = ({
    children,
    unusualKey,
    additional,
    ...props
}: {
    children: React.ReactNode;
    unusualKey?: UNUSUAL_TEXT_KEY;
    additional?: string;
} & React.HTMLAttributes<HTMLHeadingElement>) => {
    return (
        <h2
            {...(unusualKey && { "unusual-id": `${UNUSUAL_TEXT[unusualKey].TITLE}-${additional}` })}
            {...props}
            data-testid="auto-id-ecb1a571-ccce-469f-8b95-d94392fe4153">
            {children}
        </h2>
    );
};

export const UnusualH3 = ({
    children,
    unusualKey,
    additional,
    ...props
}: {
    children: React.ReactNode;
    unusualKey?: UNUSUAL_TEXT_KEY;
    additional?: string;
} & React.HTMLAttributes<HTMLHeadingElement>) => {
    return (
        <h3
            {...(unusualKey && { "unusual-id": `${UNUSUAL_TEXT[unusualKey].TITLE}-${additional}` })}
            {...props}
            data-testid="auto-id-46fe1897-467a-4ba0-b73b-f1dd8e8d7072">
            {children}
        </h3>
    );
};

export const UnusualH4 = ({
    children,
    unusualKey,
    additional,
    ...props
}: {
    children: React.ReactNode;
    unusualKey?: UNUSUAL_TEXT_KEY;
    additional?: string;
} & React.HTMLAttributes<HTMLHeadingElement>) => {
    return (
        <h4
            {...(unusualKey && { "unusual-id": `${UNUSUAL_TEXT[unusualKey].TITLE}-${additional}` })}
            {...props}
            data-testid="auto-id-00c78aa4-094f-4af5-893e-c1afe7f63f82">
            {children}
        </h4>
    );
};

export const UnusualP = ({
    children,
    unusualKey,
    additional,
    ...props
}: {
    children: React.ReactNode;
    unusualKey?: UNUSUAL_TEXT_KEY;
    additional?: string;
} & React.HTMLAttributes<HTMLParagraphElement>) => {
    return (
        <p
            {...(unusualKey && { "unusual-id": `${UNUSUAL_TEXT[unusualKey].TITLE}-${additional}` })}
            {...props}
            data-testid="auto-id-b91e3d99-8686-4219-848b-77de4d3119a5">
            {children}
        </p>
    );
};
